import { useEffect, useState } from "react";
import axios from "axios";
import { Plane } from "lucide-react";
import { useNavigate } from "react-router-dom";
import logo from "../images/Aombre-round-logo.png";

function Locations() {
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  useEffect(() => {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
    axios
      .get(`${baseUrl}get_country_city_airport_name`)
      .then((res) => {
        setLocations(res.data);
        groupLocations(res.data);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const groupLocations = (data) => {
    const grouped = {};
    data.forEach((item) => {
      const { country_name, city } = item;

      if (!grouped[country_name]) grouped[country_name] = {};
      if (!grouped[country_name][city]) grouped[country_name][city] = [];

      grouped[country_name][city].push(item);
    });
    setGroupedData(grouped);
  };

  const handleLocationSelect = (location) => {
    navigate(`/location-details?code=${location.airport_code}`);
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <img
          src={logo}
          alt="Company Logo"
          className="w-48 h-48 rounded-full animate-spin-slow"
        />
        <p className="mt-4 text-gray-700 font-semibold">Loading locations...</p>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto mt-14 ">
      <div className="text-center px-4 sm:px-6 mt-8">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#353535]">
          Our Car Rental <span className="text-[#ca8032]">Locations</span>
        </h1>
        <p className="text-sm sm:text-base md:text-md text-gray-700 font-semibold mt-2 sm:mt-3 max-w-md mx-auto mb-6">
          From airports to city centers, we’re here to make your journey
          seamless.
        </p>
      </div>

      {Object.keys(groupedData).map((country) => (
        <div key={country} className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">{country}</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Object.keys(groupedData[country]).map((city) => (
              <div
                key={city}
                className="bg-white rounded-2xl shadow-md p-5 hover:shadow-xl transition text-[#ca8032]"
              >
                <h3 className="text-xl font-bold mb-2">{city}</h3>
                <ul className="text-gray-700 space-y-1">
                  {groupedData[country][city].map((airport, idx) => (
                    <li
                      key={idx}
                      className="border-b pb-1 flex items-center gap-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => handleLocationSelect(airport)}
                    >
                      <Plane size={18} className="text-gray-600" />
                      <span>
                        {airport.airport_name} ({airport.airport_code})
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Locations;
